export default "__VITE_ASSET__DFJlYAl9__"